import * as Yup from "yup";

const usePrintAddonConfig = () => {
  const validationSchema = Yup.object({  
    print_addon_name: Yup.string().required('Print addon name is required'),
    imgpath: Yup.mixed().required('Image is required'), 
  });

  const initialValues = {
    id:0,    
    print_addon_name: '',
    imgpath: null,
  };

  return { validationSchema, initialValues };
};

export default usePrintAddonConfig;
